import { ENV } from './Config';
if (ENV === 'prod') {
  // HIDE CONSOLE LOGS ON PRODUCTION
  window.consoleOutput = { logs: [], errors: [], warnings: [] };
  console.log = console.info = (...args) =>
    window.consoleOutput.logs.push(args) && undefined;
  console.error = (...args) => window.consoleOutput.errors.push(args);
  console.warn = (...args) => window.consoleOutput.warnings.push(args);
}
/*
import DOMPurify from 'dompurify';
window.DOMPurify = DOMPurify;
*/
